// extracted by mini-css-extract-plugin
export default {"container":"login_container__P0FSm","formContainer":"login_formContainer__y2eoF"};